var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var attrs = ref.attrs
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "mr-2",
                      attrs: {
                        fab: "",
                        small: "",
                        disabled: _vm.disabled,
                        color: "primary",
                        "aria-label": _vm.$vuetify.lang.t(
                          "webmap.tooltips.home"
                        ),
                      },
                      on: { click: _vm.homeClickHandler },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_c("v-icon", { class: _vm.iconColour }, [_vm._v("mdi-home")])],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$vuetify.lang.t("webmap.tooltips.home")))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }